import React, { useContext } from 'react'
import Context from '../context/Context'
import PropTypes from 'prop-types'
import { InvoiceTypes } from '../helpers/Constants'

const OneClickPaymentText = ({ paymentApprovalTypeId }) => {
  const context = useContext(Context)

  return (parseInt(paymentApprovalTypeId) === InvoiceTypes.REGULAR)
    ? (<span>Fakturan kommer att betalas snarast möjligt.</span>)
    : (<span>Betalningen kommer att ske automatiskt på förfallodag ({context.invoice.due_date}).</span>)
}

OneClickPaymentText.propTypes = {
  paymentApprovalTypeId: PropTypes.string
}

export default OneClickPaymentText
